import { InternalSliceData } from '../types/internal/pie-chart.js';

/**
 * @param slices - Data recived from the dataSet
 * @param visibleIds - Ids of the visible slices
 * @returns The absolute and relative value calculated.
 */
export function buildCumulativeValues(
  slices: InternalSliceData[],
  visibleIds: string[],
): { absoluteValue: number; relativeValue: number } {
  return slices.reduce(
    (acc, curr) => {
      if (visibleIds.includes(curr.id)) {
        return {
          relativeValue: acc.relativeValue + curr.relativeValue,
          absoluteValue: acc.absoluteValue + curr.value,
        };
      }

      return acc;
    },
    { relativeValue: 0, absoluteValue: 0 },
  );
}
